import {
  deviceWorkStatusOptions,
  vendorDevicePhysicalStatusOptions,
  vendorDeviceRedFlagOptions,
  vendorDeviceRedFlagTypeOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfPhysical } from "components/table/columnComponents/StatusOfPhysical"
import { StatusOfWork } from "components/table/columnComponents/StatusOfWork"

export const enterpriseDevicesTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "S/N",
    type: "sort-search",
    size: "middle",
    name: "sn",
  },
  {
    title: "Work Status",
    type: "select",
    size: "small",
    name: "work_status",
    options: deviceWorkStatusOptions,
    cellComponent: StatusOfWork,
  },
  {
    title: "Physical Status",
    type: "select",
    size: "small",
    name: "phisical_status",
    options: vendorDevicePhysicalStatusOptions,
    cellComponent: StatusOfPhysical,
  },
  {
    title: "Contractor",
    type: "sort-search",
    size: "middle",
    name: "contractor_name",
  },
  {
    title: "Activation Date",
    type: "sort-date-range",
    size: "middle",
    name: "activation_date",
  },
  {
    title: "Red Flag",
    size: "small",
    type: "select",
    name: "red_flag",
    options: vendorDeviceRedFlagOptions,
  },
  {
    title: "Red Flag Type",
    type: "select",
    size: "middle",
    name: "red_flag_type",
    options: vendorDeviceRedFlagTypeOptions,
  },
  {
    title: "Customer",
    type: "sort-search",
    size: "middle",
    name: "homeowner",
  },
  {
    title: "Email",
    type: "sort-search",
    size: "middle",
    name: "email",
  },
  {
    title: "Country",
    type: "sort-search",
    size: "small",
    name: "country",
  },
  {
    title: "Zip code",
    type: "sort-search",
    size: "small",
    name: "zip_code",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address",
  },
  {
    title: "Phone",
    type: "sort-search",
    size: "middle",
    name: "phone",
  },
  {
    title: "System age",
    type: "sort-search-number",
    size: "middle",
    name: "system_age",
  },
  {
    title: "Device Location",
    type: "sort-search",
    name: "device_location",
  },
]
